import { AffiliateLogos, ContactBanner, Container, LandingBanner, Page, PhaseReveals, SubscribeForm } from '@/components';
import { CONSTANTS } from '@/constants';
import { ESize } from '@/interfaces/enums';
import { NextPage } from 'next';
import Link from 'next/link';

const LandingNextPage: NextPage = () => {
  return (
    <Page
      meta={{
        seoDescription:
          'Join our University of Sydney-led study to help parents promote healthy habits in teens. Learn how physical activity, a balanced diet, better sleep, and avoiding tobacco and alcohol can improve long-term teen health.',
        seoTitle: 'Health Promotion for Parents & Teens | Support Healthy Teen Habits',
      }}
      title={`Welcome to ${CONSTANTS.PROJECT_TITLE}`}
    >
      <LandingBanner />

      <section className="py-10 md:py-24 no-kanzi-pdf" id="eligibility">
        <Container size={ESize.SM}>
          <div className="text-center mb-8">
            <h2 className="mb-4">About our trial</h2>
          </div>
          <PhaseReveals />
        </Container>
      </section>

      <section className="bg-white py-10 md:py-24 no-kanzi-pdf">
        <Container size={ESize.SM}>
          <div className="text-center mb-8" id="express-interest-form">
            <span className="h4 color-green-500 text-uppercase">Interested in participating?</span>
            <h2 className="mb-4">Express interest in participating now!</h2>
            <p>
              If you are interested in participating in the study, please add your details below and a member of our team will contact you:
            </p>
          </div>

          <SubscribeForm />
        </Container>
      </section>

      <section className="bg-grey-300 py-10 md:py-24">
        <Container>
          <ContactBanner additionalClassNames="!mb-0" />
        </Container>
      </section>

      <section className="bg-white py-10 md:py-24">
        <Container additionalClassNames="mt-8 mb-12" size={ESize.SM}>
          <p className="h6 text-center weight-800">
            The Health4Life Parents & Teens Study has been approved by the University of Sydney (2024/338) and University of Newcastle (R-2024-0049) Human Research Ethics Committees, and NSW State Education Research and Partnerships (SERAP 74753).
          </p>
        </Container>

        <Container>
          <AffiliateLogos />
        </Container>
      </section>
    </Page>
  );
};

export default LandingNextPage;
